import React, { useState } from 'react';
import './aluminiumwindow.css';

import {
  FaBolt,
  FaThermometerHalf,
  FaLock,
  FaSyncAlt,
  FaShieldAlt,
  FaVolumeMute
} from 'react-icons/fa';



function AluminiumWindow() {
  const [activeTab, setActiveTab] = useState('types');
  const [selectedImage, setSelectedImage] = useState(0);

  const images = [
    '/window3.JPG',
    '/window2.JPG',
    '/window5.JPG',
    '/window4.JPG',
    '/window6.JPG',
  ];

 const features = [
  {
    icon: <FaBolt />,
    title: 'High Strength',
    description: 'Premium aluminium alloy construction for exceptional durability and structural integrity'
  },
  {
    icon: <FaThermometerHalf />,
    title: 'Thermal Efficiency',
    description: 'Advanced thermal break technology for superior insulation and energy savings'
  },
  {
    icon: <FaLock />,
    title: 'Enhanced Security',
    description: 'Multi-point locking systems and reinforced frames for maximum security'
  },
  {
    icon: <FaSyncAlt />,
    title: 'Custom Designs',
    description: 'Fully customizable sizes, shapes, and finishes to match any architectural style'
  },
  {
    icon: <FaShieldAlt />,
    title: 'Corrosion Resistant',
    description: 'Powder-coated finishes that resist corrosion, fading, and weathering'
  },
  {
    icon: <FaVolumeMute />,
    title: 'Noise Reduction',
    description: 'Double/triple glazing options for significant noise reduction'
  }
];


  const windowTypes = [
    { name: 'Sliding Windows', image: '/sliding.webp' },
    { name: 'Casement Windows', image: '/Casement-Window.webp' },
    { name: 'Fixed Windows', image: '/fixed window.webp' },
    { name: 'Tilt & Turn', image: '/Aluminium-Tilt-Turn.jpg' },
  ];

  const specifications = [
    { label: 'Frame Material', value: '6063-T5 Aluminium Alloy' },
    { label: 'Glass Options', value: 'Single, Double, or Triple Glazing' },
    { label: 'U-Value', value: 'As low as 0.8 W/m²K' },
    { label: 'Sound Reduction', value: 'Up to 45 dB' },
    { label: 'Colors', value: '30+ RAL Colors Available' },
    { label: 'Warranty', value: '10 Years Structural Warranty' },
    { label: 'Finish', value: 'Electrostatic Powder Coating' },
    { label: 'Security', value: 'Multi-point Locking System' }
  ];

  return (
    <div className="aluminium-window">
      {/* Hero Banner */}
      <section className="aluminium-hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">Premium Aluminium Windows</h1>
            <p className="hero-subtitle">
              Engineered for durability, efficiency, and timeless elegance. 
              Experience superior performance with our advanced aluminium window solutions.
            </p>

          </div>
          <div className="hero-image">
            <img 
              src={images[selectedImage]} 
              alt="Premium Aluminium Window" 
              className="hero-main-image"
            />
            <div className="image-thumbnails">
              {images.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Window style ${index + 1}`}
                  className={`thumbnail ${selectedImage === index ? 'active' : ''}`}
                  onClick={() => setSelectedImage(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>



      {/* Key Features */}
      <section className="features-section">
        <div className="section-header">
          <h2>Why Choose Our Aluminium Windows?</h2>
          <p>Combining innovation with exceptional craftsmanship</p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Tabs Section */}
      <section className="tabs-section">
        <div className="tabs-header">
          <button 
            className={`tab-btn ${activeTab === 'types' ? 'active' : ''}`}
            onClick={() => setActiveTab('types')}
          >
            Window Types
          </button>
          <button 
            className={`tab-btn ${activeTab === 'benefits' ? 'active' : ''}`}
            onClick={() => setActiveTab('benefits')}
          >
            Benefits
          </button>
        </div>
        
        <div className="tabs-content">
          {activeTab === 'features' && (
            <div className="specs-grid">
              {specifications.map((spec, index) => (
                <div key={index} className="spec-item">
                  <span className="spec-label">{spec.label}</span>
                  <span className="spec-value">{spec.value}</span>
                </div>
              ))}
            </div>
          )}
          
          {activeTab === 'types' && (
            <div className="window-types-grid">
              {windowTypes.map((type, index) => (
                <div key={index} className="window-type-card">
                  <img src={type.image} alt={type.name} />
                  <h4>{type.name}</h4>
                </div>
              ))}
            </div>
          )}
          
          {activeTab === 'benefits' && (
            <div className="benefits-content">
              <div className="benefit-card">
                <h3>Energy Efficiency</h3>
                <p>Our thermal break technology significantly reduces heat transfer, lowering energy costs by up to 30%.</p>
              </div>
              <div className="benefit-card">
                <h3>Low Maintenance</h3>
                <p>Powder-coated aluminium frames resist corrosion and require minimal upkeep compared to other materials.</p>
              </div>
              <div className="benefit-card">
                <h3>Sleek Design</h3>
                <p>Thinner frames with maximum glass area provide unobstructed views and modern aesthetics.</p>
              </div>
              <div className="benefit-card">
                <h3>Sustainability</h3>
                <p>100% recyclable material with eco-friendly production processes and long lifespan.</p>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>Ready to Transform Your Space?</h2>
          <p>Get a free consultation and custom quote for your project</p>
          <div className="cta-buttons">
            <a href="/contactus">
            <button className="btn-outline">Contact Us</button></a>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-grid">
          {/* <div className="faq-item">
            <h4>How long do aluminium windows last?</h4>
            <p>With proper installation and maintenance, our aluminium windows can last 40+ years due to their corrosion resistance and structural integrity.</p>
          </div> */}
          <div className="faq-item">
            <h4>Are aluminium windows energy efficient?</h4>
            <p>Yes, modern aluminium windows with thermal break technology offer excellent insulation, often outperforming other materials in energy efficiency.</p>
          </div>
          <div className="faq-item">
            <h4>Can aluminium windows be customized?</h4>
            <p>Absolutely. We offer complete customization in size, shape, color, and hardware to match your specific design requirements.</p>
          </div>
          <div className="faq-item">
            <h4>What maintenance is required?</h4>
            <p>Minimal maintenance required. Just occasional cleaning with mild soap and water is sufficient to keep them looking new.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AluminiumWindow;